import {Presenter} from '../../../../../support/with_presenter';
import {Observable, Subscription} from 'rxjs';
import {debounceThrottleAnimationFrame} from '../../../../../support/rx_debounce_throttle';
import {runInAction} from 'mobx';

export interface ClockProvider {
    updates: Observable<string | null>;
}

export class ClockPresenter implements Presenter {
    public formattedTime: string | null = null;

    private subscription: Subscription | undefined;

    constructor(private clockProvider: ClockProvider) {}

    public mount(): void {
        this.subscription = debounceThrottleAnimationFrame(this.clockProvider.updates).subscribe((formattedTime) => {
            runInAction(() => {
                this.formattedTime = formattedTime;
            });
        });
    }

    public unmount(): void {
        if (this.subscription !== undefined) {
            this.subscription.unsubscribe();
        }
    }
}
